var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_622_160",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_622_160)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 52.8001,
    cy: 13.12,
    r: 22.72,
    fill: "#F69220"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.9599,
    cy: 45.76,
    r: 22.08,
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.3599,
    cy: 14.08,
    r: 23.68,
    fill: "#EA088B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5201,
    cy: 44.16,
    r: 23.68,
    fill: "#0C9347"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingIcon);
export default __webpack_public_path__ + "static/media/loadingIcon.eaf414751bb731e3633e1de0dd6d5cd7.svg";
export { ForwardRef as ReactComponent };